import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SimpleYesNoModalComponent } from '../simple-yes-no-modal';

@Component({
  selector: 'prime-general-confirmation-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SimpleYesNoModalComponent],
  template: `<prime-simple-yes-no-modal
    (onCancel)="cancel()"
    (onConfirm)="confirm()"
    [confirmButtonLabel]="this.config?.data?.confirmButtonLabel ?? 'Confirm'"
    [cancelButtonLabel]="this.config?.data?.cancelButtonLabel ?? 'Cancel'"
    [headerLabel]="this.config?.data?.headerLabel"
    [justifyPosition]="'between'"
  >
    @if (this.config?.data?.content) {
      <ng-template #content>
        <div
          class="tw:text-[1rem] tw:whitespace-pre-line tw:p-6"
          [innerHTML]="this.config?.data?.content ?? 'Confirm?'"
        ></div>
      </ng-template>
    }
  </prime-simple-yes-no-modal>`,
})
export class GeneralConfirmationModalComponent {
  readonly config = inject<
    DynamicDialogConfig<{
      headerLabel: string;
      confirmButtonLabel?: string;
      cancelButtonLabel?: string;
      content: string;
    }>
  >(DynamicDialogConfig);
  private readonly dialogRef = inject(DynamicDialogRef, { optional: true });

  confirm(): void {
    this.dialogRef?.close(true);
  }

  cancel(): void {
    this.dialogRef?.close(false);
  }
}
